/**
 * Page affichée lorsqu'un utilisateur n'a pas les droits d'accès requis
 */

import { useNavigate } from 'react-router-dom';
import { ShieldOff } from 'lucide-react';

export function AccesRefusePage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-raised px-4">
      <div className="max-w-md w-full text-center">
        <div className="w-20 h-20 rounded-full bg-danger-light flex items-center justify-center mx-auto mb-6">
          <ShieldOff className="w-10 h-10 text-danger" />
        </div>
        <h1 className="text-2xl font-bold text-content mb-3">
          Accès refusé
        </h1>
        <p className="text-content-muted mb-2">
          Vous n'avez pas accès au module de paie.
        </p>
        <p className="text-content-subtle text-sm mb-8">
          Contactez votre administrateur pour obtenir les droits nécessaires.
        </p>
        <button
          onClick={() => navigate('/dashboard')}
          className="inline-flex items-center justify-center px-6 py-3 bg-primary text-content-inverted font-medium rounded-lg
                     hover:bg-primary-hover transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
        >
          Retour au tableau de bord
        </button>
      </div>
    </div>
  );
}

export default AccesRefusePage;
